module.exports = __webpack_public_path__ + "img/category-skill-game.e32b10ce.png";